import p6 from "../../Assets/p6.jpg"
import p2 from "../../Assets/p2.jpg"
import p1 from "../../Assets/p1.jpg"
import nohalogo from "../../Assets/nohalogo.jpeg"
import phoenixlogo from "../../Assets/phoenixlogo.jpg"
import DiyaDonationdriveimage from "../../Assets/Projects/diya donation/diya1.jpg"
import sankalp from "../../Assets/Projects/Sankalp/sankalp1.jpg"
import rangmanch from "../../Assets/Projects/rangmanch/rangmanch1.jpg"
import noha from "../../Assets/Projects/noha/noha1.jpeg"
import phoenix from "../../Assets/Projects/phoenix/phoenix1.jpeg"


export const ProjectList = [
	{
		title: "SANKALP",
		image: sankalp,
		logo: p2,
		content: "This project aims to increase the income, promote pottery skills and restore the social dignity of the potters at Kumhar Gram village, Delhi. Project Sankalp is an ongoing project that will be able to sustain these potters and their families with a regular monthly income.",
	},
	{
		title: "DIYA DONATION DRIVE",
		image: DiyaDonationdriveimage,
		logo: p6,
		content: "The NIEC-Enactus team went for the Diya Donation Drive in an underprivileged area, to apportion the collection of Diyas and chocolates that were solicited. The eyes that were wary and cautious of the bourgeois, were grateful after receiving the gifts. They expressed their gratitude and our team was pleased they could bring happiness in their lives",
	},
	{
		title: "PROJECT RANGMANCH",
		image: rangmanch,
		logo: p1,
		content: "With the aim of restoring social dignity Project Rangmanch endeavors to uplift underprivileged and commercially exploited women and enable them to become entrepreneurs, supplementing their income by providing them with the raw materials and techniques to make organic powdered colors (gulaal) for the festival of Holi. As a result of it, 5 entrepreneurs and an income of Rupees 5000 was generated and holi was made safer for the consumers.",
    },
    {
		title: "PROJECT PHEONIX",
		image: phoenix,
		logo: phoenixlogo,
		content: "Project Phoenix aims at reducing food wastage that not only affects many vegetable and fruit vendors but also the farmers and leaves many people without any food. It is not unknown that 70% of the Indian population lives below the poverty line and many cannot afford even one square meal a day. We aim to increase the shelf life of the commodities by converting the fruits and vegetables into jams, jellies and pickles",
	},
	{
		title: "NOHA",
		image: noha,
		logo: nohalogo,
		content: "Project NOHA aims to empower women by using their artistic skills such as painting and sketching on the mobile covers. We brought together the creative underprivileged ladies under one roof and then provided them the prerequisite knowledge and skills through our regular workshops. This project spreads awareness about the potential of these ladies, thus, bringing them a step closer to financial independence and socio – economic empowerment",
	},
	
]
